import { Card, Box, Typography, } from '@mui/material';
import React from 'react';
import styles from '../../devotee.module.scss';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { isNil } from 'lodash';
import { CommonButton } from '../../../common/StyledComponents/StyledFields';
import { authService } from '../../../../infrastructure/backendService';
import { useNavigate } from 'react-router-dom';
import { RoutingURLs } from '../../../common/RoutingURLs';

export interface EventCardTemplateProps {
   name: string;
   FromToDate: string;
   imgUrl?: string;
   eventUrl: string;
   isHtmlPage?: boolean;
   event_id?: string;
   eventType?: string;
}


interface CardProps {
   eventCardProps: EventCardTemplateProps;
   setIsOpen?: React.Dispatch<React.SetStateAction<boolean>> | undefined;

}

export function EventCardTemplate(props: CardProps): JSX.Element {
   const navigate = useNavigate();
   const {eventCardProps} = props

   const handleClick = (): void => {
     if (authService.isAuthenticated()) {
       navigate(
         `${RoutingURLs.donations}?donationID=${props?.eventCardProps?.event_id}`
       );
     } else if (!isNil(props.setIsOpen)) {
       navigate(
         `${RoutingURLs.home}?donationID=${props?.eventCardProps?.event_id}`
       );
     }
   };

   const handleEventClick = (url: string) => {
     props?.eventCardProps?.isHtmlPage
       ? navigate(`/htmltEventscontent?eventType=${eventCardProps?.eventType}&eventName=${eventCardProps?.name}`)
       : (window.location.href = url);
   };

   return (
      <Card
         key={props.eventCardProps.name}
         className={styles.EventsCardTemplateDetails}
         // sx={{
         //    width: "100%",
         //    backgroundColor: '#FFF9E4',
         //    boxShadow: ' none',
         //    display: "flex",
         //    justifyContent: "space-between",
         //    height: "auto",
         //    backgrounColor: '#FFF9E4',

         // }}
      >
         <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
            <img src={props.eventCardProps.imgUrl} alt="panaroma" className={styles.Image}  onClick={(event: any) => {event.preventDefault(); handleEventClick(props.eventCardProps.eventUrl)}}/>
            <Box className={styles.nameDate}>
               <Typography className={styles.eventTitle}
                  onClick={(event: any) => {event.preventDefault(); handleEventClick(props.eventCardProps.eventUrl)}}
               >
                  {props.eventCardProps.name}
               </Typography>
               <Box sx={{ display: "flex", paddingTop: "10px" }}>
                  {props.eventCardProps.FromToDate ?
                     <CalendarTodayOutlinedIcon className={styles.calenderIcon} /> : ""}
                  <Typography className={styles.calenderDate}>
                     {props.eventCardProps.FromToDate}
                  </Typography>
               </Box>
            </Box>
         </Box>

         <Box sx={{ paddingBottom: '25px', paddingTop: '25px' }}>
            <CommonButton onClick={handleClick} className={styles.donateButton}>Donate</CommonButton>
         </Box>
      </Card>
   );
}
